// BabyMobile.ca — product page live banner calculator: pick the letter
// count (and decoration style, when the product has one) from the real
// Shopify variants we actually stock, then type a word of exactly that
// length and preview each felt letter's colour.
(function () {
  var root = document.querySelector('[data-rd-banner-calc]');
  if (!root) return;

  var FELT_COLORS = window.RD_FELT_COLORS || [];
  var DEFAULT_NAMES = ['Pink', 'Baby Blue', 'Mellow Yellow', 'Spring Green', 'Lavender', 'Cream', 'Peachy Pink', 'Sage'];

  var variantsScript = document.querySelector('[data-rd-banner-variants]');
  var variants = [];
  try {
    variants = JSON.parse(variantsScript ? variantsScript.textContent : '[]');
  } catch (e) {
    variants = [];
  }
  if (!variants.length) return;

  var hasDecor = variants.some(function (v) { return v.decor != null && v.decor !== ''; });

  var letterGroups = [];
  (function () {
    var seen = {};
    variants.forEach(function (v) {
      if (seen[v.letters]) return;
      seen[v.letters] = true;
      letterGroups.push({
        letters: v.letters,
        price: v.price,
        available: variants.some(function (x) { return x.letters === v.letters && x.available; })
      });
    });
    letterGroups.sort(function (a, b) { return a.letters - b.letters; });
  })();

  var decorOptions = [];
  if (hasDecor) {
    var seenDecor = {};
    variants.forEach(function (v) {
      if (v.decor == null || seenDecor[v.decor]) return;
      seenDecor[v.decor] = true;
      decorOptions.push(v.decor);
    });
  }

  var letterPickerEl = root.querySelector('[data-rd-banner-variant-picker]');
  var decorPickerEl = root.querySelector('[data-rd-banner-decor-picker]');
  var wordInput = root.querySelector('[data-rd-banner-word]');
  var tilesEl = root.querySelector('[data-rd-banner-tiles]');
  var hintEl = root.querySelector('[data-rd-banner-hint]');
  var totalEl = root.querySelector('[data-rd-banner-total]');
  var variantInput = document.querySelector('[data-rd-banner-variant-input]');
  var wordField = document.querySelector('[data-rd-banner-word-field]');
  var colorsField = document.querySelector('[data-rd-banner-colors-field]');
  var submitBtn = document.querySelector('[data-rd-banner-submit]');
  var shareBtn = document.querySelector('[data-rd-banner-share]');
  var topPriceEl = document.querySelector('[data-rd-price-amount]');

  if (tilesEl) {
    tilesEl.setAttribute('role', 'group');
    tilesEl.setAttribute('aria-label', 'Banner preview');
  }

  var letterColors = {};
  var selectedLetters = null;
  var selectedDecor = null;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function defaultColorAt(i) {
    var name = DEFAULT_NAMES[i % DEFAULT_NAMES.length];
    for (var j = 0; j < FELT_COLORS.length; j++) {
      if (FELT_COLORS[j].name === name) return FELT_COLORS[j];
    }
    return FELT_COLORS[0] || { name: '', hex: '#EFEDF9' };
  }

  function colorAt(i) {
    return letterColors[i] || defaultColorAt(i);
  }

  function resolveVariant() {
    if (selectedLetters == null) return null;
    if (hasDecor && !selectedDecor) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.letters === selectedLetters && (!hasDecor || v.decor === selectedDecor)) return v;
    }
    return null;
  }

  function renderLetterChips() {
    if (!letterPickerEl) return;
    letterPickerEl.innerHTML = '';
    letterGroups.forEach(function (g) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'rd-banner-calc-chip';
      chip.disabled = !g.available;
      chip.innerHTML = '<span>' + g.letters + ' letters</span><span class="rd-banner-calc-chip-price">' + money(g.price) + '</span>';
      chip.addEventListener('click', function () {
        selectedLetters = g.letters;
        syncLetterChipSelection();

        if (wordInput) {
          wordInput.disabled = false;
          wordInput.maxLength = g.letters;
          wordInput.placeholder = 'Exactly ' + g.letters + ' letters';
          if (wordInput.value.length > g.letters) {
            wordInput.value = wordInput.value.slice(0, g.letters);
          }
        }
        if (totalEl) totalEl.textContent = money(g.price);
        if (topPriceEl) topPriceEl.textContent = money(g.price);

        update();
      });
      letterPickerEl.appendChild(chip);
    });
    syncLetterChipSelection();
  }

  function syncLetterChipSelection() {
    if (!letterPickerEl) return;
    var chips = letterPickerEl.querySelectorAll('.rd-banner-calc-chip');
    letterGroups.forEach(function (g, i) {
      chips[i].classList.toggle('is-selected', selectedLetters === g.letters);
    });
  }

  function renderDecorChips() {
    if (!decorPickerEl) return;
    decorPickerEl.innerHTML = '';
    decorOptions.forEach(function (name) {
      var available = variants.some(function (v) { return v.decor === name && v.available; });
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'rd-banner-calc-chip';
      chip.disabled = !available;
      chip.innerHTML = '<span>' + name + '</span>';
      chip.addEventListener('click', function () {
        selectedDecor = name;
        syncDecorChipSelection();
        update();
      });
      decorPickerEl.appendChild(chip);
    });
    syncDecorChipSelection();
  }

  function syncDecorChipSelection() {
    if (!decorPickerEl) return;
    var chips = decorPickerEl.querySelectorAll('.rd-banner-calc-chip');
    decorOptions.forEach(function (name, i) {
      chips[i].classList.toggle('is-selected', selectedDecor === name);
    });
  }

  function renderTiles(word) {
    if (!tilesEl) return;
    if (window.RDCloseColorPicker) window.RDCloseColorPicker();
    tilesEl.innerHTML = '';
    word.split('').forEach(function (ch, i) {
      var tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'rd-banner-calc-tile';
      tile.style.background = colorAt(i).hex;
      tile.style.setProperty('--i', i);
      tile.textContent = ch === ' ' ? '·' : ch.toUpperCase();
      tile.setAttribute('aria-label', 'Letter ' + (ch === ' ' ? 'space' : ch.toUpperCase()) + ', colour ' + colorAt(i).name + ' — tap to change');
      tile.title = colorAt(i).name + ' — tap to change this letter\'s colour';
      tile.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!window.RDOpenColorPicker) return;
        window.RDOpenColorPicker(tile, function (c) {
          letterColors[i] = c;
          tile.style.background = c.hex;
          tile.title = c.name + ' — tap to change this letter\'s colour';
          tile.setAttribute('aria-label', 'Letter ' + (ch === ' ' ? 'space' : ch.toUpperCase()) + ', colour ' + c.name + ' — tap to change');
          updateColorsField(word);
        });
      });
      tilesEl.appendChild(tile);
    });
  }

  function updateColorsField(word) {
    if (!colorsField) return;
    var names = word.split('').map(function (ch, i) {
      return ch.toUpperCase() + ':' + colorAt(i).name;
    });
    colorsField.value = names.join(', ');
  }

  function update() {
    if (selectedLetters == null) {
      if (hintEl) hintEl.textContent = 'Choose a letter count to start typing';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Choose a letter count';
      }
      return;
    }

    var raw = wordInput ? wordInput.value : '';
    var word = raw.toUpperCase().slice(0, selectedLetters);
    if (wordInput && wordInput.value !== word) wordInput.value = word;

    renderTiles(word);
    updateColorsField(word);
    if (wordField) wordField.value = word;

    if (hasDecor && !selectedDecor) {
      if (hintEl) hintEl.textContent = 'Choose a decoration style above';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Choose a decoration';
      }
      return;
    }

    var variant = resolveVariant();
    if (variantInput && variant) variantInput.value = variant.id;

    if (!variant || !variant.available) {
      if (hintEl) hintEl.textContent = 'That combination is currently sold out';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sold out';
      }
      return;
    }

    var remaining = selectedLetters - word.length;
    if (remaining > 0) {
      if (hintEl) hintEl.textContent = remaining + ' more letter' + (remaining === 1 ? '' : 's') + ' to go · tap a letter to change its colour';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Add to cart';
      }
    } else {
      if (hintEl) hintEl.textContent = selectedLetters + ' felt letters · tap a letter to change its colour';
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Add to cart';
      }
    }
  }

  if (wordInput) {
    wordInput.addEventListener('input', update);
  }

  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      var word = wordField ? wordField.value : (wordInput ? wordInput.value : '');
      var url = window.location.origin + window.location.pathname + '?banner=' + encodeURIComponent(word);
      var restoreText = shareBtn.textContent;
      function done() {
        shareBtn.textContent = '✓ Link copied';
        window.setTimeout(function () {
          shareBtn.textContent = restoreText;
        }, 2500);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, done);
      } else {
        var temp = document.createElement('textarea');
        temp.value = url;
        temp.style.position = 'fixed';
        temp.style.opacity = '0';
        document.body.appendChild(temp);
        temp.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(temp);
        done();
      }
    });
  }

  renderLetterChips();
  if (hasDecor) renderDecorChips();

  // Deep-link from a shared banner: ?banner=WORD pre-selects the matching
  // letter-count variant and pre-fills the word.
  var params = new URLSearchParams(window.location.search);
  var sharedWord = params.get('banner');
  if (sharedWord) {
    var sharedLetters = sharedWord.toUpperCase().replace(/[^A-Z0-9]/g, '').length;
    var matchGroup = letterGroups.find(function (g) { return g.letters === sharedLetters && g.available; });
    if (matchGroup) {
      var chip = letterPickerEl ? Array.prototype.find.call(
        letterPickerEl.querySelectorAll('.rd-banner-calc-chip'),
        function (c, i) { return letterGroups[i].letters === sharedLetters; }
      ) : null;
      if (chip) chip.click();
      if (hasDecor && decorPickerEl) {
        var firstDecorChip = decorPickerEl.querySelector('.rd-banner-calc-chip:not(:disabled)');
        if (firstDecorChip) firstDecorChip.click();
      }
      if (wordInput) {
        wordInput.value = sharedWord.toUpperCase();
      }
    }
  }

  update();
})();
